import React from "react";
import PropTypes from "prop-types";
import { formatPercentage } from "@signolteam/shared/units-of-measure";
import { ONBOARDING_COMMITMENT_OPTIONS } from "@src/constants/constants";
import AppUtils from "@src/utils/appUtils";
import CardContainer from "@src/components/cards/CardContainer";
import HorizontalLayout from "@src/components/cards/HorizontalLayout";
import ImageWrapper from "@src/components/atoms/ImageWrapper";
import { getSocialProofSentence } from "../utility/textFormatterHelpers";

const CommitmentCard = ({
  getDynamicContent,
  commitmentDate,
  userCommitment,
  customerCommitments,
  customer,
}) => {
  /**
   * @returns a string eg. "So have 46% of DemoLine pilots using Signol."
   * @see https://www.figma.com/design/qg5Ymw1eSpcirBFPNgZCp6/APP-DESIGNS?node-id=11866-6319&t=rCFWqCLXRVKzWx4l-4
   */
  const socialProofSentence = React.useMemo(() => {
    return getSocialProofSentence(
      getDynamicContent,
      userCommitment,
      customerCommitments,
      customer,
    );
  }, [customerCommitments, userCommitment, getDynamicContent, customer.name]);

  if (!userCommitment) return <></>;
  const { overviewImage, overviewText } =
    ONBOARDING_COMMITMENT_OPTIONS[userCommitment] || {};
  const commitmentImageUrl = getDynamicContent(overviewImage);

  return (
    <CardContainer padding={false} bgColor="primary-100" shadow={false}>
      <HorizontalLayout ratio={[1, 2]} gap={2}>
        <ImageWrapper src={commitmentImageUrl} size="lg" />
        <div className="flex px-7 py-4 items-center">
          <div>
            {getDynamicContent("captain__commitments__commitment_summary", {
              COMMITMENT_DESCRIPTION: overviewText,
              COMMITMENT_DATE: commitmentDate,
            })}
            {socialProofSentence && <span> {socialProofSentence}</span>}
          </div>
        </div>
      </HorizontalLayout>
    </CardContainer>
  );
};

export const commitmentCardControls = {
  getDynamicContent: {
    propType: PropTypes.func,
    description: "Function to get dynamic content",
    disable: true,
  },
  commitmentDate: {
    propType: PropTypes.string,
    description: "Commitment date string",
    controlType: "text",
  },
  userCommitment: {
    propType: PropTypes.string,
    description: "User commitment text",
    controlType: "text",
  },
  customerCommitments: {
    propType: PropTypes.array,
    description: "Array of customer commitments",
    controlType: "object",
    defaultValue: [],
  },
  customer: {
    propType: PropTypes.object,
    description: "Customer data object",
    controlType: "object",
  },
};
CommitmentCard.propTypes = AppUtils.getPropTypeFromControls(
  commitmentCardControls,
);

export default CommitmentCard;
